import { SlotTrakMachinesCommonServer, machineUrl } from '../../common/Server'
import simpleQuery from '../../../utils/server/simpleQuery'
import simplePutOrPostSave from '../../../utils/server/simplePutOrPostSave'
import simpleDelete from '../../../utils/server/simpleDelete'

export default class DesertDiamondMachineServer
  extends SlotTrakMachinesCommonServer {

  constructor($http, $q, simpleQuery, simplePutOrPostSave, simpleDelete) {
    super($http, $q, simpleQuery, simplePutOrPostSave, simpleDelete)

    this.slotTypesQuery = simpleQuery(machineUrl + '/slotTypes')
    this.displayTypesQuery = simpleQuery(machineUrl + '/displayTypes')
    this.screenTypesQuery = simpleQuery(machineUrl + '/screenTypes')
    this.modelNumbersQuery = simpleQuery(machineUrl + '/modelNumbers')
    this.leasedQuery = simpleQuery(machineUrl + '/leased')
    this.leaseCategoriesQuery = simpleQuery(machineUrl + '/leaseCategories')
    this.playerTrackingTypesQuery = simpleQuery(machineUrl + '/playerTrackingTypes')
    this.sbEgmQuery = simpleQuery(machineUrl + '/sbEgm')
    this.slotTypesSave = simplePutOrPostSave(machineUrl + '/slotTypes')
    this.displayTypesSave = simplePutOrPostSave(machineUrl + '/displayTypes')
    this.screenTypesSave = simplePutOrPostSave(machineUrl + '/screenTypes')
    this.modelNumbersSave = simplePutOrPostSave(machineUrl + '/modelNumbers')
    this.leasedSave = simplePutOrPostSave(machineUrl + '/leased')
    this.leaseCategoriesSave = simplePutOrPostSave(machineUrl + '/leaseCategories')
    this.playerTrackingTypesSave = simplePutOrPostSave(machineUrl + '/playerTrackingTypes')
    this.sbEgmSave = simplePutOrPostSave(machineUrl + '/sbEgm')
    this.progressiveLabelQuery = simpleQuery(machineUrl + '/progressiveLabels', { OrderBy: 'Name' })
    this.progressiveLabelSave = simplePutOrPostSave(machineUrl + '/progressiveLabels')
    this.progressiveTypeQuery = simpleQuery(machineUrl + '/progressiveTypes', { OrderBy: 'Name' })
    this.progressiveTypeSave = simplePutOrPostSave(machineUrl + '/progressiveTypes')
    this.addMachineConfigurationReview = machineConfigurationId => $http({
      url: machineUrl + `/configurations/${machineConfigurationId}/reviews`,
      method: 'post'
    })
    this.getMachineConfigurationReviews = machineConfigurationId => $http({
      url: machineUrl + `/configurations/${machineConfigurationId}/reviews`,
      method: 'get'
    })

    this.machineAreaSave = simplePutOrPostSave(machineUrl + '/machineArea')
    this.machineAreaQuery = simpleQuery(machineUrl + '/machineArea')

    this.machineBankConfigSave = simplePutOrPostSave(machineUrl + '/machineBankConfig')
    this.machineBankConfigQuery = simpleQuery(machineUrl + '/machineBankConfig')

    this.conversionTypeQuery = simpleQuery(machineUrl + '/conversionTypes')
    this.conversionTypeSave = simplePutOrPostSave(machineUrl + '/conversionTypes')
  }
}
DesertDiamondMachineServer.$inject = ['$http', '$q', simpleQuery.vsName, simplePutOrPostSave.vsName, simpleDelete.vsName]
DesertDiamondMachineServer.vsName = 'slotTrakMachinesServer'
DesertDiamondMachineServer.vsNgType = 'service'